<template>
  <pagefra>
    <div
      class="partsProposal container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            :model="form"
            inline
            class="toolbar-form"
            @submit.native.prevent
          >
            <el-form-item :label="$l('关键字')">
              <el-input
                v-model="form.keyword"
                :placeholder="$l('合同号/工号/地盘名称')"
                clearable
                style="width: 240px"
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="70"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('标题')"
              prop="title"
              align="center"
              min-width="160"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :label="$l('合同号')"
              prop="contract_code"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('工号')"
              prop="asset_num"
              align="center"
              min-width="160"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              prop="proj_name"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('提交人')"
              prop="apply_user"
              align="center"
              min-width="140"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘联系人手机号')"
              prop="proj_user_phone"
              align="center"
              min-width="140"
            ></el-table-column>
            <el-table-column
              :label="$l('状态')"
              prop="status_flag"
              align="center"
              min-width="100"
            ></el-table-column>
            <el-table-column
              :label="$l('报告生成时间')"
              prop="gen_pdf_time"
              align="center"
              width="180"
            ></el-table-column>
            <el-table-column
              :label="$l('创建时间')"
              prop="create_time"
              align="center"
              width="180"
            ></el-table-column>
            <el-table-column
              :label="$l('操作')"
              align="center"
              width="90"
              fixed="right"
              v-if="hasPermission('下载')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  :disabled="!scope.row.download_url"
                  @click="download(scope.row)"
                  >{{ $l("下载") }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "partsProposal",
  mixins: [global],
  components: {
    panel,
  },
  data() {
    return {
      form: {
        keyword: "",
      },
      tableData: [],
      loading: false,
      fullLoading: false,
    };
  },
  created() {
    this.pageConfig.pageChangeCallback = this.loadData;
  },
  mounted() {
    this.loadData();
  },
  methods: {
    search() {
      this.pageConfig.currentPage = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.$http
        .post(this.$apiConfig.get_fd_proposal_accessories_list_url, {
          current: this.pageConfig.currentPage,
          size: this.pageConfig.pageSize,
          keyword: this.form.keyword,
        })
        .then((response) => {
          this.loading = false;
          const result = response.data;
          if (result.code == 0) {
            const data = result.data || {};
            this.tableData = data.records || [];
            this.pageConfig.total = data.total || 0;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    download(row) {
      if (row.download_url) {
        window.open(row.download_url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.partsProposal {
}
</style>
